"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("../../elements/button/Button");
var _Plus24PxOutlined = _interopRequireDefault(require("../../elements/icons-jb/Plus24PxOutlined"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ADD_ADDRESS_LINE_BUTTON = {
  component: _Button.TertiaryButton,
  extra: true,
  name: 'add-address-line-button',
  props: {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: "Add address line"
    }),
    IconComponent: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Plus24PxOutlined["default"], {}),
    style: {
      marginTop: '8px',
      "float": 'right'
    }
  }
};
var _default = exports["default"] = ADD_ADDRESS_LINE_BUTTON;